import React, { useEffect, useRef, memo } from 'react'

// TradingView market overview: tabbed asset list with live prices and sparklines,
// themed with our teal (up) / red (down) palette on a transparent background
const config = {
  colorTheme: 'dark',
  dateRange: '1D',
  showChart: true,
  locale: 'en',
  width: '100%',
  height: '100%',
  largeChartUrl: '',
  isTransparent: true,
  showSymbolLogo: true,
  showFloatingTooltip: true,
  plotLineColorGrowing: 'rgba(37, 172, 208, 1)',
  plotLineColorFalling: 'rgba(255, 100, 100, 1)',
  gridLineColor: 'rgba(255, 255, 255, 0.04)',
  scaleFontColor: 'rgba(255, 255, 255, 0.45)',
  belowLineFillColorGrowing: 'rgba(37, 172, 208, 0.12)',
  belowLineFillColorFalling: 'rgba(255, 100, 100, 0.12)',
  belowLineFillColorGrowingBottom: 'rgba(37, 172, 208, 0)',
  belowLineFillColorFallingBottom: 'rgba(255, 100, 100, 0)',
  symbolActiveColor: 'rgba(37, 172, 208, 0.12)',
  tabs: [
    {
      title: 'Stocks',
      symbols: [
        { s: 'NASDAQ:AAPL', d: 'Apple' },
        { s: 'NASDAQ:GOOGL', d: 'Alphabet' },
        { s: 'NASDAQ:AMZN', d: 'Amazon' },
        { s: 'NASDAQ:META', d: 'Meta Platforms' },
        { s: 'NASDAQ:MSFT', d: 'Microsoft' },
        { s: 'NASDAQ:NVDA', d: 'NVIDIA' },
        { s: 'NASDAQ:TSLA', d: 'Tesla' },
      ],
    },
    {
      title: 'Crypto',
      symbols: [
        { s: 'BINANCE:BTCUSDT', d: 'Bitcoin' },
        { s: 'BINANCE:ETHUSDT', d: 'Ethereum' },
        { s: 'BINANCE:SOLUSDT', d: 'Solana' },
        { s: 'BINANCE:XRPUSDT', d: 'XRP' },
        { s: 'BINANCE:BNBUSDT', d: 'BNB' },
      ],
    },
    {
      title: 'Forex',
      symbols: [
        { s: 'FX:EURUSD', d: 'EUR / USD' },
        { s: 'FX:GBPUSD', d: 'GBP / USD' },
        { s: 'FX:USDJPY', d: 'USD / JPY' },
        { s: 'FX:AUDUSD', d: 'AUD / USD' },
        { s: 'FX:USDCAD', d: 'USD / CAD' },
      ],
    },
    {
      title: 'Indices',
      symbols: [
        { s: 'FOREXCOM:SPXUSD', d: 'S&P 500' },
        { s: 'FOREXCOM:NSXUSD', d: 'Nasdaq 100' },
        { s: 'FOREXCOM:DJI', d: 'Dow Jones' },
        { s: 'INDEX:DEU40', d: 'DAX' },
      ],
    },
    {
      title: 'Commodities',
      symbols: [
        { s: 'TVC:GOLD', d: 'Gold' },
        { s: 'TVC:SILVER', d: 'Silver' },
        { s: 'TVC:USOIL', d: 'Crude Oil' },
        { s: 'NYMEX:NG1!', d: 'Natural Gas' },
      ],
    },
  ],
}

const MarketOverviewWidget = () => {
  const containerRef = useRef(null)
  const scriptAdded = useRef(false)

  useEffect(() => {
    if (scriptAdded.current || !containerRef.current) return
    const script = document.createElement('script')
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js'
    script.type = 'text/javascript'
    script.async = true
    script.innerHTML = JSON.stringify(config)
    containerRef.current.appendChild(script)
    scriptAdded.current = true
  }, [])

  return (
    <div className="tradingview-widget-container" ref={containerRef} style={{ height: '100%', width: '100%' }}>
      <div className="tradingview-widget-container__widget" style={{ height: '100%', width: '100%' }}></div>
    </div>
  )
}

export default memo(MarketOverviewWidget)
